// extracted by mini-css-extract-plugin
module.exports = {"scorersSegment":"_47a1dd6","statsTable":"_7977422","topPerformers":"_c631644","title":"_4ebb642"};